/* eslint-disable no-unused-vars */
import { useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { getStorage } from 'utils/localstorage'
import axios from 'utils/axios/modules/account'
import * as yup from 'yup'

function useIdHook() {
  const user_id = getStorage('crm_id')

  const [resultDisplay, setResultDisplay] = useState(false)
  const [errorDisplay, setErrorDisplay] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [errors, setErrors] = useState([])

  const history = useHistory()

  const execUpdateTanakaId = useCallback(async (email) => {
    setIsLoading(true)

    const body = {
      dev_unconfirmed_tanaka_id: email,
    }

    await axios
      .updateTanakaId(body)
      .then(() => {
        setResultDisplay(true)
        setIsSuccess(true)
      })
      .catch((errorMessages) => {
        setErrorDisplay(true)
        setErrors(errorMessages)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  const schema = yup.object().shape({
    email: yup.string().required('項目が未入力です').spe,
    re_email: yup.string().test('email-match', 'メールアドレスが一致していません', function(value) {
      const { email } = this.parent

      return email === value
    }),
  })

  return {
    user_id,
    resultDisplay,
    setResultDisplay,
    errorDisplay,
    setErrorDisplay,
    isLoading,
    isSuccess,
    errors,
    setErrors,
    history,
    execUpdateTanakaId,
    schema,
  }
}

export default useIdHook
